import { useFormatDate } from 'components/misc/FormattedDate';
import { DelegationAlert } from 'pages/delegations/DelegationAlert';
import { Link } from 'react-router-dom';
import { ClientIdentificationDto } from 'types/clientIdentification';
import { t } from 'utils/getTranslations';
import { receivedLine } from './receiptDates';

/** The standing notice of a received or a superseded client identification; nothing while it is in progress. */
export function ClientIdentificationNotices({ assessment }: { assessment: ClientIdentificationDto }) {
    const formatDate = useFormatDate();
    if (assessment.statusShown === 'RECEIVED') {
        return (
            <DelegationAlert severity="success" role="status">
                {receivedLine(formatDate(assessment.receivedOn) ?? '', assessment.receivedByName)}
            </DelegationAlert>
        );
    }
    if (assessment.statusShown === 'SUPERSEDED') {
        return (
            <DelegationAlert
                severity="info"
                role="status"
                action={
                    assessment.supersededByContractId ? (
                        <Link to={`/contract/${assessment.supersededByContractId}`} className="text-link font-medium">
                            {t('client-identification.open-newer-version')}
                        </Link>
                    ) : undefined
                }
            >
                {t('client-identification.superseded-banner')}
            </DelegationAlert>
        );
    }
    return null;
}
